/** Box host + embed token (not returned by /tenant/features). */

const BOX_HOST = "https://ap-platforms.app.box.com";
const BOX_EMBED_TOKEN = "j6nkt15qx29hiqs3kd339qk56ah1rmr8";

export const BOX_SIGN_IN_LABEL = "AP-Platforms";

export function getBoxFolderUrl(folderId: number | null | undefined): string {
  return `${BOX_HOST}/folder/${folderId ?? ""}`;
}

export function getBoxEmbedUrl(folderId: number | null | undefined): string {
  const id = folderId ?? "";
  return (
    `${BOX_HOST}/embed/folder/${id}?s=${BOX_EMBED_TOKEN}` +
    "&sortColumn=name&sortDirection=asc&view=icon" +
    "&hideNavigationControls=true&hideHubsGallery=true" +
    "&showParentPath=false&frameBorder=0"
  );
}
